import {_utils, observers} from "./utils/_utils.js";
import {_libs} from "./utils/_libs.js";
import {_state, getLocalState} from "./state/state.js";
import {header} from "./components/header.js";
import {heroHomeBlock} from "./components/blocks/firsts/home-hero.js";
import {otherLogosBlock} from "./components/blocks/other/logos.js";
import {servicesBlock} from "./components/blocks/other/services.js";
import {otherVehiclesBlock} from "./components/blocks/other/vehicles.js";
import {otherIndustriesBlock} from "./components/blocks/other/industries.js";
import {otherWhyChooseBlock} from "./components/blocks/other/why-choose.js";
import {servicesFaqBlock} from "./components/blocks/services/faq.js";
import {servicesOtherBlock} from "./components/blocks/services/other.js";
import {heroDriverBlock} from "./components/blocks/firsts/hero-driver.js";
import {customSelect} from "./components/custom-select.js";
import {creditApplicationBlock} from "./components/blocks/special/credit-application.js";
import {contactFormsSend} from "./components/contact-forms-send.js";
import {blogContentMenu} from "./components/blocks/blog/content-menu.js";
import {otherCtaBlock} from "./components/blocks/other/cta.js";

document.addEventListener('DOMContentLoaded', async (event) => {
    await Promise.all([
        _libs._lazyLoad(),
        getLocalState(),
    ]);

    let isUserInteracted = true;
    _state.interactionEvents.forEach(event => {
        window.addEventListener(event, async () => {
            if (isUserInteracted) {
                isUserInteracted = false;
                await Promise.all([
                    _utils.initOnUserInteraction(),
                    _libs.initOnUserInteraction(),
                ])
                _state.updateState({isUserActive: true});
            }
        });
    });

    await Promise.all([
        _utils.init(),
        _libs.init(),
        observers.init(),

        header(),
        // customSelect(),

        //blocks
            //first
            heroHomeBlock(),
            heroDriverBlock(),
            //other
            otherLogosBlock(),
            servicesBlock(),
            otherVehiclesBlock(),
            otherIndustriesBlock(),
            otherWhyChooseBlock(),
            // services
            servicesFaqBlock(),
            servicesOtherBlock(),
            // special
            creditApplicationBlock(),
            // general
            contactFormsSend(),
            // blog
            blogContentMenu(),
    ]).then(async () => {
        await Promise.all([
            _utils.anchorInUrl(),
        ])
    });
});